import { useQuery } from '@tanstack/react-query';
import { getSoftwareCompanies } from '../../api/organizations';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings } from '../../AppContainer';

export const softwareCompaniesQueryKey = ['softwareCompanies'] as const;

export function useSoftwareCompanies() {
  const { apiUrl } = useProductSettings<Settings>();
  return useQuery({
    queryKey: softwareCompaniesQueryKey,
    queryFn: () => getSoftwareCompanies(apiUrl),
    staleTime: 5 * 60 * 1000,
  });
}
